// extracted by mini-css-extract-plugin
module.exports = {"not-found":"NotFound_not-found__nY7_j"};